import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Disease } from '../models/disease';
import { StorageService } from './storage.service'
import { AlertController } from '@ionic/angular';
import { NetworkService } from './network.service';
import { UserService } from './user.service';
import { DateUtilsService } from './date-utils.service';
import { IndexedDbService } from './indexed-db.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DiseaseService {
  diseases: Disease[] = [];

  constructor(
    private http: HttpClient,
    public storageService: StorageService,
    public networkService: NetworkService,
    private translate: TranslateService,
    private dateUtils: DateUtilsService,
    private userService: UserService,
    public indexedDbService: IndexedDbService,
    public alertController: AlertController) { }
}
